import React, {useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useReportAuth } from '../context/ReportAuthContext';

const REPORTS = [
  {
    id: 'basic',
    name: 'Basic PPSR Check',
    price: process.env.REACT_APP_BASIC_REPORT_PRICE ? parseFloat(process.env.REACT_APP_BASIC_REPORT_PRICE) : 8.00,
    badge: 'Most Popular',
    badgeClass: '',
    description: 'Essential PPSR checks to verify vehicle history',
    features: [
      { included: true,  text: 'Official PPSR Certificate' },
      { included: true,  text: 'Finance Owing Check' },
      { included: true,  text: 'Written Off Records' },
      { included: true,  text: 'Stolen Vehicle Check' },
      { included: true,  text: 'Security Interest Details' },
      { included: true,  text: 'VIN Validation' },
      { included: true,  text: 'Instant PDF Download' },
      { included: false, text: 'Odometer History' },
      { included: false, text: 'Registration Timeline' },
      { included: false, text: 'Market Valuation' },
    ],
  },
  {
    id: 'comprehensive',
    name: 'Comprehensive Report',
    price: process.env.REACT_APP_COMPREHENSIVE_REPORT_PRICE ? parseFloat(process.env.REACT_APP_COMPREHENSIVE_REPORT_PRICE) : 18.00,
    badge: 'Best Value',
    badgeClass: 'pricing-badge-premium',
    cardClass: 'pricing-card-featured',
    description: 'Complete vehicle history with enhanced details',
    features: [
      { included: true, text: 'Everything in Basic, plus:',  bold: true },
      { included: true, text: 'Official PPSR Certificate' },
      { included: true, text: 'Finance Owing Check' },
      { included: true, text: 'Written Off Records' },
      { included: true, text: 'Stolen Vehicle Check' },
      { included: true, text: 'Security Interest Details' },
      { included: true, text: 'VIN Validation' },
      { included: true, text: 'Odometer History & Analysis', bold: true },
      { included: true, text: 'Complete Registration Timeline', bold: true },
      { included: true, text: 'Market Valuation Guide', bold: true },
      { included: true, text: 'First Sale Information', bold: true },
    ],
  },
];

export default function ReportTypes() {

  const navigate = useNavigate();
  const { searchData, setSelectedReport } = useReportAuth();

  function handleSelect(report) {
    setSelectedReport({ reportType: report.id, price: report.price, name: report.name });
    navigate('/checkout');
  }

const inputRefBasic = useRef(null);
const inputRefComprehensive = useRef(null);

useEffect(() => {
  const session_reporttype = sessionStorage.getItem('session_reporttype');

  if (session_reporttype !== null) {
    //alert(session_reporttype);
    if(session_reporttype === 'basic')
    {
      setTimeout(() => {

      inputRefBasic.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });

        // move 60px upward after scroll
  window.scrollBy({
    top: -60,
    behavior: 'smooth',
  });
    
      inputRefBasic.current?.focus();
      
      }, 100);
    }
    else
    {
      setTimeout(() => {
        inputRefComprehensive.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
    
                // move 60px upward after scroll
  window.scrollBy({
    top: -60,
    behavior: 'smooth',
  });

        inputRefComprehensive.current?.focus(); 
      }, 100);
    }
    sessionStorage.removeItem('session_reporttype');
  }
}, []);

  return (
    <>
      <Header />

      <section className="page-header">
        <div className="container">
          <h1>Choose Your PPSR Report</h1>
          <p>Select the report that best suits your needs. All reports are instant and include official PPSR certificate.</p>
        </div>
      </section>

      {searchData && (
        <section className="vehicle-info-bar">
          <div className="container">
            <div className="vehicle-info-content">
              <div className="vehicle-info-item">
                <strong>Vehicle:</strong> <span>{searchData.plate}</span>
              </div>
              <div className="vehicle-info-item">
                <strong>State:</strong> <span>{searchData.state}</span>
              </div>
              <button className="btn-link" onClick={() => navigate('/')}>
                <i className="fas fa-edit"></i> Change Vehicle
              </button>
            </div>
          </div>
        </section>
      )}

      <section className="pricing-section">
        <div className="container">
          <div className="pricing-grid">
            {REPORTS.map((report) => (
              <div key={report.id} className={`pricing-card${report.cardClass ? ` ${report.cardClass}` : ''}`}>
                <div className={`pricing-badge${report.badgeClass ? ` ${report.badgeClass}` : ''}`}>
                  {report.badge}
                </div>
                <div className="pricing-header">
                  <h3>{report.name}</h3>
                  <div className="pricing-price">
                    <span className="currency">$</span>
                    <span className="amount">{Math.floor(report.price)}</span>
                    <span className="cents">.{String(report.price.toFixed(2)).split('.')[1]}</span>
                  </div>
                  <p className="pricing-description">{report.description}</p>
                </div>
                <ul className="pricing-features">
                  {report.features.map((f, i) => (
                    <li key={i} className={!f.included ? 'feature-disabled' : ''}>
                      <i className={`fas ${f.included ? 'fa-check' : 'fa-times'}`}></i>
                      {f.bold ? <strong>{f.text}</strong> : f.text}
                    </li>
                  ))}
                </ul>
                {report.name.includes('Basic') ? (
                <button ref={inputRefBasic} className="btn btn-primary btn-large" onClick={() => handleSelect(report)}>
                  Select {report.name}
                </button>
                ) : (
                <button  ref={inputRefComprehensive} className="btn btn-primary btn-large" onClick={() => handleSelect(report)}>
                  Select {report.name}
                </button>
                )}
              </div>
            ))}
          </div>

          <div className="comparison-note">
            <div className="comparison-note-icon"><i className="fas fa-info-circle"></i></div>
            <div className="comparison-note-content">
              <h4>Need help choosing?</h4>
              <p>The <strong>Basic PPSR Check</strong> is perfect if you just need to verify there's no finance owing or if the vehicle is stolen/written-off. Choose the <strong>Comprehensive Report</strong> for complete peace of mind with odometer verification, registration history, and market valuation.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="trust-section">
        <div className="container">
          <div className="trust-grid">
            {[
              { icon: 'fa-shield-alt', title: 'Secure Payment',    sub: 'Powered by Stripe' },
              { icon: 'fa-lock',       title: 'Data Protected',    sub: '256-bit SSL Encryption' },
              { icon: 'fa-certificate',title: 'Official PPSR',     sub: 'Government Register' },
              { icon: 'fa-bolt',       title: 'Instant Delivery',  sub: 'Report in Seconds' },
            ].map((b) => (
              <div key={b.title} className="trust-badge">
                <i className={`fas ${b.icon}`}></i>
                <h4>{b.title}</h4>
                <p>{b.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
